import { type UseQueryResult, useQuery } from 'react-query';
import { TotpEnrollmentService } from '../../services/wealthlane-identity-services';

// Define the response type
interface TotpEnrollmentQrCodeResponse {
  sharedKey: string;
  authenticatorUri: string;
}

const useGetTotpEnrollmentQrCode = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setQrCodeUri: (uri: string) => void
): UseQueryResult<TotpEnrollmentQrCodeResponse> => {
  const totpEnrollmentQrCode = useQuery<TotpEnrollmentQrCodeResponse>(
    ['getTotpEnrollmentQrCode'],
    async () => {
      const response = await handleRequest(
        TotpEnrollmentService.getApiIdentityApiTotpEnrollmentQrCode()
      );
      if (response) {
        setQrCodeUri(response.authenticatorUri ?? '');
      }
      return response as TotpEnrollmentQrCodeResponse;
    }
  );
  return totpEnrollmentQrCode;
};

export default useGetTotpEnrollmentQrCode;
